import type {
  ReceivablesControllerGetDownpaymentsData,
  ReceivablesControllerGetItemsData,
  ReceivablesDownpaymentsDto,
  ReceivablesItemsDto,
  ReceivablesProblemsDto,
  ReceivablesSummaryDto,
} from '@carvia/ros-client-types';
import { Service } from './http-service';

class ReceivablesService extends Service {
  async getSummary(
    params?: Pick<
      NonNullable<ReceivablesControllerGetItemsData['query']>,
      'invoiceTypes' | 'hasPeriodicInvoicing' | 'isDeposit' | 'search'
    >,
  ) {
    const res = await this.httpClient.get<ReceivablesSummaryDto>(`${this.endpoint}/summary`, {
      params,
    });
    return res.data;
  }

  async getItems(params: ReceivablesControllerGetItemsData['query']) {
    const res = await this.httpClient.get<ReceivablesItemsDto>(`${this.endpoint}/items`, {
      params,
    });
    return res.data;
  }

  async getProblems() {
    const res = await this.httpClient.get<ReceivablesProblemsDto>(`${this.endpoint}/problems`);
    return res.data;
  }

  async getDownpayments(params?: ReceivablesControllerGetDownpaymentsData['query']) {
    const res = await this.httpClient.get<ReceivablesDownpaymentsDto>(
      `${this.endpoint}/downpayments`,
      { params },
    );
    return res.data;
  }
}

export const receivablesService = new ReceivablesService('/receivables');
